import { forwardRef, type InputHTMLAttributes } from 'react';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> & {
  onChange?: (valor: string) => void;
};

/**
 * Uppercase de campo de texto SEM perder a posicao do cursor. Use no lugar de
 * `e.target.value.toUpperCase()` dentro de um `onChange`:
 *
 *     onChange={(e) => setDescricao(upperMantendoCursor(e))}
 *
 * ⚠️ O `.toUpperCase()` cru tem um defeito que so aparece EDITANDO NO MEIO de um texto ja
 * escrito: ao digitar uma letra minuscula, o valor que o React devolve difere do que esta no
 * DOM, entao ele reescreve o `value` inteiro do input — e atribuir `value` joga o cursor pro
 * FIM. Quem digita sempre no fim (caixa de busca) nunca ve; quem corrige uma palavra no meio de
 * uma descricao gravada perde o lugar a cada tecla. (Relato dele em 05/09/2026, editando a
 * "Descricao do fornecedor" no modal do Catalogo.)
 *
 * O conserto e' passar o texto ja em maiuscula pro DOM ANTES do React olhar, e devolver a
 * selecao pro lugar: ai o valor do React e o do DOM batem e nao ha reescrita. E' o mesmo miolo
 * do <UpperInput/> — extraido porque a maioria dos campos da casa e' `<input>` cru com estilo
 * proprio, e trocar o elemento so pra ganhar isto sairia caro.
 */
export function upperMantendoCursor(e: React.ChangeEvent<HTMLInputElement>): string {
  const el = e.currentTarget;
  const start = el.selectionStart;
  const end = el.selectionEnd;
  const upper = el.value.toUpperCase();
  if (el.value !== upper) {
    el.value = upper;
    if (start !== null && end !== null) el.setSelectionRange(start, end);
  }
  return upper;
}

// Input que forca uppercase preservando posicao do cursor.
export const UpperInput = forwardRef<HTMLInputElement, Props>(function UpperInput(
  { onChange, value, ...rest }, ref,
) {
  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    onChange?.(upperMantendoCursor(e));
  }
  return <input ref={ref} type="text" value={value ?? ''} onChange={handleChange} data-componente="007" {...rest} />;
});
